import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { AssetListFromBalancesType } from 'utils/asset-list';

import { DISPLAY_DIGITS_AFTER_ZERO } from '../../constants/base';
import ArrowDownSmallIcon from '../../images/ArrowDownSmallIcon.svg';
import CheckIcon from '../../images/check_icon.svg';
import { displayFullAmount } from '../../utils/balance-tools';
import { AmountInput } from '../Dialog/TransactionDialog/AmountInput';

interface TokenInputProps {
  tokenList: AssetListFromBalancesType[];
  selectedToken: AssetListFromBalancesType;
  inputPlaceholder: string;
  disabled?: boolean;
  errorText?: string;
  onTokenChange: (token: AssetListFromBalancesType) => void;
  onAmountChange: (val: string) => void;
}

// TODO_R: [FRS]
// TODO_R: move into SendDialog/components/
export const TokenInput = (props: TokenInputProps) => {
  const {
    inputPlaceholder,
    tokenList,
    selectedToken,
    disabled,
    errorText,
    onAmountChange,
    onTokenChange,
  } = props;
  const [tokenListShown, setTokenListShown] = useState(false);

  // TODO_R: no mutation
  let currentTokenBalance;

  if (!selectedToken) {
    currentTokenBalance = 0;
  } else if (selectedToken.balance) {
    currentTokenBalance =
      Number(selectedToken.balance).toFixed(selectedToken.decimals) + ' ' + selectedToken.symbol;
  }

  const handleTokenSelect = (token: typeof selectedToken) => {
    onTokenChange?.(token);
    setTokenListShown(false);
  };

  // TODO_R: replace this logic and JSX with @material-ui select
  // #beginRegion
  const showRef = useRef(tokenListShown);

  useEffect(() => {
    showRef.current = tokenListShown;
  }, [tokenListShown]);
  // #endRegion

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="flex justify-between items-end">
        <span className="text-r14 text-white">Token</span>
        <span className="text-r12 text-regular">Balance: {currentTokenBalance}</span>
      </div>
      <div className="flex h-48 gap-8">
        <div
          className={classNames(
            'flex-1 bg-black-3 rounded-[8px] border-[.5px] flex items-center w-full relative',
            tokenListShown ? 'border-primary' : 'border-black-4'
          )}
        >
          {selectedToken ? (
            <div className="w-full">
              <button
                className="flex items-center gap-8 w-full h-48 px-8 sm:px-16"
                onClick={() => setTokenListShown((prevState) => !prevState)}
              >
                <img className="w-32" src={selectedToken.tokenIcon} alt="" />
                <div className="text-r14 text-white">{selectedToken.symbol}</div>
                <img className="w-16 h-16 ml-auto" src={ArrowDownSmallIcon} alt="" />
              </button>
              {tokenListShown && (
                <div className="fixed inset-0" onClick={() => setTokenListShown(false)} />
              )}
              <div
                className="w-full absolute top-56 bg-black-3 z-50 border border-black-4 rounded-[12px] mt-4 max-h-[120px] overflow-y-auto"
                hidden={!tokenListShown}
              >
                {tokenList.map((token, index) => {
                  return (
                    <div
                      key={`token-input-${index}`}
                      className="flex items-center px-8 py-4 gap-8"
                      onClick={() => handleTokenSelect(token)}
                    >
                      <img className="w-24 h-24" src={token.tokenIcon} alt="" />
                      <div className="flex flex-col">
                        <div className="text-m13 text-white">{token.symbol}</div>
                        <div className="text-r12 text-regular">
                          {displayFullAmount(+token.balance, DISPLAY_DIGITS_AFTER_ZERO)}
                        </div>
                      </div>
                      <div className="flex flex-1 justify-end">
                        {selectedToken.symbol === token.symbol && <img src={CheckIcon} alt="" />}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="text-r14 text-error px-16 opacity-80">No tokens available</div>
          )}
          {!!errorText && errorText !== '' && <span className="error">{errorText}</span>}
        </div>
        <div className="flex-1">
          <AmountInput
            disabled={disabled || tokenList.length === 0}
            onChange={onAmountChange}
            placeholder={inputPlaceholder}
          />
        </div>
      </div>
    </div>
  );
};
